import {AnimationMixer} from "three";

export const AnimationMixerState: new () => Map<string, AnimationMixer> = Map;
